export enum Environment {
  local = 'local',
  staging = 'staging',
  production = 'production',
}

export const isProd = (environment: string) => {
  return environment === Environment.production;
};

export const isLocal = (environment: string) => {
  return environment === Environment.local;
};

export const isStaging = (environment?: string) => {
  return !environment || environment === Environment.staging;
};
